import { combineReducers } from "redux";
import settingReducer from "./settingsSlice";
import profileReducer from "./profileSlice";

const rootReducer = combineReducers({
  profile: profileReducer,
  setting: settingReducer,
});

export default rootReducer;
